import { Box, Text } from '@chakra-ui/react'
import {
    type ContentPlaceholderProps,
  } from './content-placeholder'
import { useColorPalette } from './ui/color-palette-context';
import config from '../config.json';
  
  export const Footer = (props: ContentPlaceholderProps) => {
    const { colorPalette } = useColorPalette();

    return (
      <Box as="footer" role="contentinfo" height={'24px'} pl={{ base: '10px', md: '30px' }} pr={{ base: '10px', md: '30px' }} bgColor={`${colorPalette}.solid`} display={'flex'} justifyContent={'space-between'} alignItems={'center'} >
        <Text mb={0} fontSize={'xs'} color={'white'}>
            <Box as="span" display={{ base: 'none', md: 'inline' }}>Version </Box>
            {config.version}
        </Text>
        <Text fontSize={'xs'} color={'white'}>
            <Box as="span" display={{ base: 'none', md: 'inline' }}>© 2025 NYS Office of Information Technology Services</Box>
            <Box as="span" display={{ base: 'inline', md: 'none' }}>© 2025 NYS ITS</Box>
        </Text>
      </Box>
    )
  }
  